<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
    <template v-slot:main>
      <head-utils title="Criar carteira de corretor"/>
      <breadcrumb
          :items="[{
                      label: 'Pesquisar carteiras de corretores',
                      path: '/broker_customers_wallets'
                      }, {
                      label: 'Criar carteira de corretor',
                      path: '/broker_customers_wallets/new'
                    }]"/>

      <form @submit.prevent.stop="submit" novalidate>
        <ibox>
          <template v-slot:title v-if="!$appUtils.isMobile()">
            <h5>Dados da carteira de corretor</h5>
          </template>
          <template v-slot:content>
            <div class="container-fluid-grid">
              <div class="form-row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="brokerCustomerWalletEditCategory" class="required">Corretor</label>
                    <select id="brokerCustomerWalletEditCategory"
                            class="form-control form-control-sm"
                            :key="entity.user_id"
                            :disabled="is_loading_cg || is_loading_products || is_loading_wallets"
                            @change="loadBrokerWallets($event)"
                            v-model="entity.user_id">
                      <option selected :value="undefined">[SELECIONE]</option>
                      <option v-for="c in brokers"
                              :key="c.id"
                              :value="c.id">{{ c.name }} {{ c.last_name }}
                      </option>
                    </select>
                    <field-messages :errors="errors.user_id"/>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <Loading :visible="is_loading_cg"/>
                  <ul class="list-to-add">
                    <li>
                      <input type="search"
                             v-model="txt_group_criteria"
                             class="t-c plch-center"
                             :disabled="is_loading_cg || is_loading_products || is_loading_wallets"
                             placeholder="GRUPO"/>
                      <input class="checkbox n green"
                             @change="onSelectAllCustomerGroups($event)"
                             :checked="selected_customer_groups.length === customer_groups.size"
                             :disabled="is_loading_cg || is_loading_products || is_loading_wallets"
                             type="checkbox"/>
                    </li>
                    <li v-for="(cg, idx) in filtered_groups_to_add"
                        :key="cg.id">
                      <label :for="`group_${idx}`" class="c-p">{{ cg.name }}</label>
                      <input class="checkbox n green"
                             :id="`group_${idx}`"
                             @change="onSelectCustomerGroup($event)"
                             :checked="selected_customer_groups.includes(cg.id)"
                             :disabled="is_loading_cg || is_loading_products || is_loading_wallets"
                             :value="cg.id"
                             type="checkbox">
                    </li>
                  </ul>
                </div>
                <div class="col-md-6 form-group">
                  <Loading :visible="is_loading_products"/>
                  <ul class="list-to-add">
                    <li>
                      <input type="search"
                             v-model="txt_product_criteria"
                             :disabled="is_loading_cg || is_loading_products || is_loading_wallets"
                             class="t-c plch-center"
                             placeholder="PRODUTOS"/>
                      <input class="checkbox n green"
                             @change="onSelectAllProducts($event)"
                             :checked="selected_products.length === products.length"
                             :disabled="is_loading_cg || is_loading_products || is_loading_wallets"
                             type="checkbox">
                    </li>
                    <li v-for="(p, idx) in filtered_products_to_add"
                        :key="p.id">
                      <label :for="`prd_${idx}`" class="c-p">{{ p.name }}</label>
                      <input class="checkbox n green"
                             :id="`prd_${idx}`"
                             @change="onSelectProduct($event)"
                             :checked="selected_products.includes(p.id)"
                             :disabled="is_loading_cg || is_loading_products || is_loading_wallets"
                             :value="p.id"
                             type="checkbox">
                    </li>
                  </ul>
                  <div class="d-f d-f-r">
                    <div class="btn-group btn-group-sm m-t-10px" role="group" aria-label="Comandos de Pesquisa">
                      <router-link to="/broker_customers_wallets" class="btn btn-dark btn-sm"><svg-icon icon="search"/> Pesquisar</router-link>
                      <button class="btn btn-sm btn-theme-1"
                              type="button"
                              title="Adicionar grupo(s) e produto(s) selecionado(s) ao corretor"
                              @click="save"
                              :disabled="selected_customer_groups.length === 0 || selected_products.length === 0 || is_loading_cg || is_loading_products || is_loading_wallets"
                      >
                        <svg-icon icon="plus"/>&nbsp;Adicionar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!!entity.user_id">
                <Loading :visible="is_loading_wallets"/>
                <table class="table table-striped table-sm table-bordered">
                  <thead class="thead-dark thead-center">
                  <tr>
                    <th>GRUPO CLIENTE</th>
                    <th>PRODUTOS</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(bcw, idx) in filtered" :key="idx">
                    <td class="v-m">{{bcw.customer_group_name}}</td>
                    <td class="v-m">
                      <div class="products-container" ref="productsContainer" @wheel="handelWheel($event, idx)">
                        <span v-for="(prd, index) in bcw.products" :key="index">
                          {{prd.name}}
                        </span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <Pagination
                    mode="callback"
                    @paging="paginate"
                    :page_size="page_size"
                    :current_page="page_number"
                    :total_entries="filter_length"/>
              </div>
            </div>
          </template>
        </ibox>
      </form>
    </template>
  </DefaultTmpl>
</template>
<script>
import DefaultTmpl from '@/templates/DefaultTmpl'
import FieldMessage from "@/components/particles/FieldMessage.vue";
import CRUDEdit from "@/mixins/CRUDEdit";
import {createNamespacedHelpers} from "vuex";
import Pagination from "@/components/Pagination.vue";
import Loading from "@/components/particles/Loading.vue";

const {mapGetters, mapActions} = createNamespacedHelpers('broker_customers_wallets');
const {mapGetters: productGetters, mapActions: productActions} = createNamespacedHelpers('products');

export default {
  name: "BrokerCustomersWalletsEdit",
  components: {Loading, Pagination, FieldMessage, DefaultTmpl},
  mixins: [
    CRUDEdit.mount('broker_customers_wallets')
  ],
  data() {
    return {
      txt_group_criteria: '',
      txt_product_criteria: '',
      groups_products_to_add: new Map(),
      customer_groups: new Map(),
      selected_customer_groups: [],
      selected_products: [],
      broker_customers_wallets: [],
      page_number: 1,
      page_size: 20,
      filter_length: 0,
      is_loading_wallets: false,
      is_loading_cg: false,
      is_loading_products: false,
    }
  },
  methods: {
    ...mapActions(['loadBrokers']),
    ...productActions(['loadAll']),
    createEntity() {
      return {
        user_id: undefined,
      }
    },
    onLoadSuccess(entity) {
      this.entity = {...entity};
      if (!!entity.user_id) {
        this.loadBrokerWallets({target: {value: entity.user_id}});
      }
    },
    paginate(page) {
      this.page_number = page;
    },
    onSelectCustomerGroup(event) {
      let id = event.target.value;
      let index = this.selected_customer_groups.indexOf(id);
      if (index > -1) {
        this.$delete(this.selected_customer_groups, index);
      } else {
        this.$set(this.selected_customer_groups, this.selected_customer_groups.length, id);
      }
    },
    onSelectProduct(event) {
      let id = event.target.value;
      let index = this.selected_products.indexOf(id);
      if (index > -1) {
        this.$delete(this.selected_products, index);
      } else {
        this.$set(this.selected_products, this.selected_products.length, id);
      }
    },
    onSelectAllCustomerGroups(event) {
      if (event.target.checked) {
        this.$set(this, 'selected_customer_groups', Array.from(this.customer_groups.keys()));
      } else {
        this.$set(this, 'selected_customer_groups', []);
      }
    },
    onSelectAllProducts(event) {
      if (event.target.checked) {
        this.$set(this, 'selected_products', this.products.map(p => p.id));
      } else {
        this.$set(this, 'selected_products', []);
      }
    },
    loadBrokerWallets(event) {
      let id = event.target.value;
      if (this.$appUtils.isEmpty(id)) {
        this.broker_customers_wallets = [];
        return;
      }
      this.$set(this, 'selected_customer_groups', []);
      this.$set(this, 'selected_products', []);
      this.is_loading_wallets = true;
      this.$appHttp.get(`/v1/broker_customers_wallets/load_wallets_by_user?user_id=${id}`)
          .then(({data}) => {
            this.broker_customers_wallets = data;
          })
          .catch(err => {
            this.$appUtils.vibrate();
            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar carregar carteiras...'}), this.$appStorage.getUser().name);
            console.error(`Fail to load broker wallets[${id}]`, err);
          })
          .finally(() => {
            this.is_loading_wallets = false;
          })
    },
    loadCustomerGroups() {
      this.is_loading_cg = true;
      this.$appHttp.get('/v1/customers/load_customer_groups?order=name')
          .then(({data}) => {
            this.customer_groups = new Map(data.map(cg => [cg.id, cg]));
          })
          .catch(err => {
            this.$appUtils.vibrate();
            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar carregar grupos de clientes...'}), this.$appStorage.getUser().name);
            console.error(`Fail to load customer groups`, err);
          })
          .finally(() => {
            this.is_loading_cg = false;
          })
    },
    save() {
      if (this.$appUtils.isEmpty(this.entity.user_id)) {
        this.$snotify.error('Selecione um corretor para adicionar carteiras', this.$appStorage.getUser().name);
        return;
      }

      if (this.selected_customer_groups.length === 0) {
        this.$snotify.error('Selecione ao menos um grupo de cliente para adicionar carteiras', this.$appStorage.getUser().name);
        return;
      }

      if (this.selected_products.length === 0) {
        this.$snotify.error('Selecione ao menos um produto para adicionar carteiras', this.$appStorage.getUser().name);
        return;
      }

      this.is_loading_wallets = true;

      this.$appHttp.post('/v1/broker_customers_wallets', {
        user_id: this.entity.user_id,
        customer_group_ids: this.selected_customer_groups,
        product_ids: this.selected_products
      })
          .then(() => {
            this.$snotify.success('Carteiras adicionadas com sucesso', this.$appStorage.getUser().name);

            this.loadBrokerWallets({
              target: {value: this.entity.user_id}
            })
          })
          .catch(err => {
            this.$appUtils.vibrate();
            this.$snotify.error(this.$t('common.tryContactSupport', {msg: 'Ops... Aconteceu algum problema para tentar adicionar carteiras...'}), this.$appStorage.getUser().name);
            console.error(`Fail to add broker wallets`, err);
          })
          .finally(() => {
            this.selected_products.length = 0;
            this.selected_customer_groups.length = 0;

            this.is_loading_wallets = false;

            Promise.all([
              this.loadCustomerGroups(),
              this.loadAll()
            ])
          })
    },
    hasAllProductsInGroup(group_id) {
      const prdIds = this.broker_customers_wallets.entries.filter(p => p.customer_group_id === group_id).map(p => p.product_id);

      return prdIds.length === this.products.length && this.products.every(p => prdIds.includes(p.id));
    },
    handelWheel(e, idx) {
      e.preventDefault()
      if (e.deltaY !== 0) {
        this.$refs.productsContainer[idx].scrollLeft += e.deltaY; // Scroll horizontal
      }
    }
  },
  created() {
    this.loadBrokers();
    this.loadCustomerGroups();
    this.loadAll();
  },
  computed: {
    ...mapGetters(['brokers']),
    ...productGetters({products: 'all'}),
    filtered_groups_to_add() {
      let array = Array.from(this.customer_groups.values());

      if (!!this.entity.user_id) {
        array = array.filter(cg => !this.hasAllProductsInGroup(cg.id));
      }

      if (!this.$appUtils.isEmpty(this.txt_group_criteria)) {
        array = array.filter(cg => cg.name.toLowerCase().indexOf(this.txt_group_criteria.trim().toLowerCase()) > -1)
      }

      return array;
    },
    filtered_products_to_add() {
      let array = [...this.products];

      if (!this.$appUtils.isEmpty(this.txt_product_criteria)) {
        array = array.filter(cg => cg.name.toLowerCase().indexOf(this.txt_product_criteria.trim().toLowerCase()) > -1)
      }

      return array;
    },
    filtered() {
      const page = this.page_number - 1;

      let array = [...(this.broker_customers_wallets.entries || [])];

      this.filter_length = array.length;

      return array.slice((page) * this.page_size, (page + 1) * this.page_size);
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/scrollbar";
$item-height: 32px;

.list-to-add {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: calc(#{$item-height} * 10);
  overflow-y: auto;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;

  @include scrollbar(2px, #eee, #999, #666);
  scroll-behavior: smooth;
  scroll-snap-type: y mandatory;
  scrollbar-width: thin;

  li {
    display: grid;
    grid-template-columns: auto 30px;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
    scroll-snap-align: start;
    height: $item-height;

    > label {
      display: inline-flex;
      align-items: center;
      line-height: 100%;
    }

    > input[type="search"] {
      border: none;
      outline: none;
    }

    &:first-child {
      position: sticky;
      top: 0;
      background-color: #fff;
      z-index: 2;
    }

    &:not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }
  }
}

.products-container {
  overflow-x: auto;
  flex-direction: row;
  display: flex;
  flex-wrap: nowrap;
  justify-content: start;
  align-items: center;
  gap: 5px;
  scrollbar-width: thin;
  scroll-snap-type: x mandatory;

  > span {
    display: inline-block;
    text-overflow: unset;
    white-space: nowrap;
    background-color: $theme_color_eight;
    color: #fff;
    height: 17px;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
    text-decoration: none;
    transition: background-color .3s ease;
    scroll-snap-align: start;
    user-select: none;
  }
}
</style>